import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { array, string } from "prop-types";
import { differenceInHours } from "date-fns";

import CustomStoryCard10 from "../../molecules/CustomStoryCard10";
import { DfpComponent } from "../../ads/dfp-component";
import More from "../../atoms/More";
import DfpContainer from "../../ads/dfp-container";

import { staticTexts } from "../../utils/Translate";
import { getSlotId } from "../../utils/utils";

import "./notificationStories.m.css";

const NotificationStories = ({ stories = [], lang = "bn" }) => {
  const [notificationStories, setNotificationStories] = useState([]);
  const [currentNotificationsCount, setCurrentNotificationsCount] = useState(null);

  const ads = {
    R2: {
      en: "EnPalo_ROS_300x250_R2",
      bn: "News_336x280_R2",
    },

    R3: {
      en: "EnPalo_ROS_336x280_R3",
      bn: "News_336x280_R3",
    },
  };

  useEffect(() => {
    const latestNotifications = stories.length
      ? stories.filter(
          (item) => differenceInHours(new Date(), new Date(item.created_time + " GMT".toLocaleString())) <= 48
        )
      : [];
    setNotificationStories(latestNotifications);
    setCurrentNotificationsCount(latestNotifications.length);
  }, [stories]);

  const storiesDom = notificationStories.map((story, index) => (
    <React.Fragment key={index}>
      {index !== 0 && (index % 10 === 5 || index === 5) && (
        <DfpContainer>
          <div styleName="ad-wrapper" className="adsBox">
            <div styleName="ad-slot">
              <DfpComponent type={ads.R3[lang]} slotId={getSlotId(ads.R3[lang], "notificationStories-ad", index / 5)} />
            </div>
          </div>
        </DfpContainer>
      )}
      <CustomStoryCard10 story={story} storyType="notifications" />
    </React.Fragment>
  ));

  const fetchNotifications = () => {
    const offset = notificationStories.length;
    const limit = 10;
    fetch(`/feapi/push-engage-notifications?limit=${limit}&offset=${offset}`)
      .then((res) => res.json())
      .then((resp) => {
        setCurrentNotificationsCount(resp.notifications ? resp.notifications.length : 0);
        setNotificationStories([...notificationStories, ...(resp.notifications || [])]);
      });
  };

  return (
    <React.Fragment>
      <div styleName="wrapper">
        {global.isDesktop && <div />}
        <div>
          {storiesDom}
          {notificationStories.length >= 8 && currentNotificationsCount > 0 && (
            <div styleName="load-more-view">
              <More type="load-more" text={staticTexts(lang).more} onClick={fetchNotifications} />
            </div>
          )}
        </div>
        <div>
          <DfpContainer>
            <div styleName="side-ad" className="adsBox">
              <DfpComponent type={ads.R2[lang]} slotId={getSlotId(ads.R2[lang], "notificationStories-sideAd")} />
            </div>
          </DfpContainer>
        </div>
      </div>
    </React.Fragment>
  );
};

NotificationStories.propTypes = {
  stories: array,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], "bn"),
});

export default connect(mapStateToProps)(NotificationStories);
